import React, { useState } from "react";
import maintenanceIcon from "../../assets/maintenance.svg";
import './app-maintenance.css'

function AppMaintenance () {
    return (
        <div className="app-maintenance-main">
            <div className="maintenance-vector-wrapper mt-16">
            <img src={maintenanceIcon} className="maintenance-vector"/>
            </div>
            <h4 className="text-purple-800 text-2xl text-center font-semibold mt-16 mb-4">We'll be back soon!</h4>
            <div className="maintenance-msg text-center w-full flex justify-center">
            <p className="text-gray-500 w-80 mb-4">Benepay is undergoing some maintenance. Please try again after sometime</p>
            </div>
        </div>

    )
}

export default AppMaintenance;